module.exports = __webpack_public_path__ + "img/alert_play.ee14b2ea.png";